<template>

    <div class="dashBox">
        <div class="dashTitle">
            异常分类统计
        </div>

            <!-- 系统列表 -->
            <a-table :columns="columns" :data-source="tableData"  :scroll="{ x: clientWidth}" :pagination="false"  :loading="tloading" rowKey="id"
            bordered size="middle" @change="handleTableChange">
                <template slot="readParams" slot-scope="text,record">
                    <a-icon style="color:#1890ff;"  size="large" type="file-text" @click="handleParams(record)" />
                </template>
            </a-table>
        
            <a-pagination  style="margin-left:20px;display:inline-flex;margin-top:20px;" v-model="pagenation.current" :pageSize="pagenation.pageSize" :total="pagenation.total" @change="handlePageChange" show-less-items show-quick-jumper />

    </div>
</template>

<script>
let pagenation ={
    current:1,
    pageSize:20,
    total:0
};

const columns = [
    {
        title: "序号",
        width: 80,
        align: "center",
        customRender: (text, record, index) => {
            let { current, pageSize } = pagenation;
            return (Number(current) - 1) * Number(pageSize) + index + 1;
        },
    },
    
    {
        title: "异常信息",
        dataIndex: "js_err_msg",
        align: "center",
        sorter: true,
        ellipsis:true,
    },
    {
        title: "影响用户数",
        dataIndex: "usercount",
        width:150,
        align: "center",
        defaultSortOrder :'descend',
        sorter: true,
    },

    {
        title: "异常数",
        dataIndex: "errcount",
        width:150,
        ellipsis: true,
        align: "center",
        sorter: true,
    },
    {
        title: "详情",
        width:80,
        scopedSlots: { customRender: 'readParams' },
        align: "center",
        ellipsis: true,
    },

  
];
export default {
    components:{
    },
    data () {
        return {
            tloading:false,
            pagenation,
            columns,
            tableData:[],
            clientWidth:800,
            sTimeRange:"",
            selectedWebSys:"",
            tempEnv:'',
            currentModalData:{},
            orderStr:' order by usercount desc'
        }
    },
    mounted(){
       
    },
    props:{

    },
    methods:{

        handleTableChange(d,v,sorter) {
            if(sorter.order){
                this.orderStr = ' order by ' + sorter.field + ' ' + sorter.order.replace('end','');
            }
            else{
                this.orderStr = '';
            }
            this.loadData(null,null);

        },
       
        handlePageChange(v){
            this.pagenation.current = v
            this.loadData(null,null);
        },
        loadData(selectedEnv,selectedWebSys,sTimeRange,page){
            if(sTimeRange && selectedWebSys){
                this.sTimeRange = sTimeRange;
                this.tempEnv = selectedEnv;
                this.selectedWebSys = selectedWebSys;
            }
            if(page){
                this.pagenation.current = page
            }

            let queryStr = " * | select count(1) as errcount,count(distinct(\"__tag__:__client_ip__\")) as usercount,js_err_msg from log  "  +
            "where log_type = 'js-error' and project_name = '" + this.selectedWebSys + "' group by js_err_msg " + this.orderStr
            let that = this;
            that.tloading = true;
            let sTime = this.sTimeRange.split('~')[0];
            let eTime = this.sTimeRange.split('~')[1];
            let starttime = (new Date(sTime).getTime())/1000;
            let endtime = (new Date(eTime).getTime())/1000;
            let params = {
                projectname:'fp-zl-device',
                logstorename:this.tempEnv,
                starttime:starttime,
                endtime:endtime,
                sql:queryStr,
                pageSize:that.pagenation.pageSize,
                offset:(that.pagenation.current - 1) * that.pagenation.pageSize,
                reverse:false,
                paged:true,
                timeout:15000,
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/querylog",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    result.list.forEach(element => {
                        element.id = that.G.generateUUID()
                    });
                    that.tableData = result.list;
                    that.pagenation.total = parseInt(result.count);
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
        handleParams(item){
            localStorage.setItem('monitorweb_logs_searchp','');

            this.$router.push({
                path: '/monitorweb/logs',
                query:{
                    logType:'js-error',
                    timeRange:this.sTimeRange,
                    js_err_msg:item.js_err_msg
                }
            })
        },

    }
}

</script>
<style scoped>

.dashBox{
        min-height: 395px;
        border: 1px solid lightgray;
        padding-bottom: 20px;
        background-color: white;

    }
    .dashTitle{
        width: 100%;
        height: 40px;
        color: #00c1de;
        line-height:38px;
        padding:0 10px;
        border-bottom: 1px solid lightgray;
    cursor: default;

    }

    .list_item_box{
        width: auto;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 10px 13px;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -moz-box-direction: normal;
        -ms-flex-flow: row nowrap;
        flex-flow: row nowrap;
    }
    .list_item_data{
        flex: 1;
        box-sizing: border-box;
        display: block;
    }
    .list_item_data_item{
        font-family: Roboto Mono,Consolas,Menlo,Courier,monospace;
        display: block;
        word-break: break-word;
        word-wrap: break-word;
        line-height: 16px;
        margin-right: 5px;
        margin-bottom: 10px;
    }
    .list_item_data_item_key{
        display: inline-flex;
        color: #333;
        font-size: 12px;
        background-color: rgba(0,86,144,.1);
        border-radius: 2px;
        padding: 1px 3px!important;
        margin: 2px 0;
    }

</style>
